import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoLocalMapasState } from './types'

export const getters: GetterTree<PronosticoLocalMapasState, RootState> = {
  getPronosticoLocalMapas (state: PronosticoLocalMapasState) {
    return state
  }
}
